import CvcdExit from './CvcdExit'
import { CVCD_EXIT_ENABLED } from '../../chain/merchant/network'
import manifest from '../../chain/merchant/manifest.json'
import {useState} from 'react'
import {styled} from '@mui/material/styles';
import Container from '@mui/material/Container';
// // import Alert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';


import { 
    WhiteSpace,
    Button,
    TextLinear,
    TextMax,
    TextM,
    TextS,
    Hr,
    Input,
    Card,
    FlexBLock,
    LoadingBlock,
    Dialog,
} from '../../components';

import {IconImg} from '../../components/Icon'

import {
    EtherToInt,
} from '../../ethers/e'

import {
    useBalance
} from '../../context/balance'

import {
    useSwap,
    useCvcdSwapData,
    useStakeCvcForCvcdSwap,
    useClaimCvcdSwapAll,
    useReleaseCvcdSwapUSDTAll
} from '../../hook/v2/useNode'

const STAKE_WEEKS = 7
const STAKE_REWARD_RATE = 0.2

function StakeReward(amount, swapData) {
    const value = Number(amount)
    const rewardRate = StakeRewardRate(swapData)
    return Number.isFinite(value) && value > 0 ? value * rewardRate : 0
}

function StakeRewardRate(swapData) {
    return swapData.rewardDenominator > 0
        ? swapData.rewardRate / swapData.rewardDenominator
        : STAKE_REWARD_RATE
}

function StakeRewardLabel(swapData) {
    return `${Math.round(StakeRewardRate(swapData) * 10000) / 100}% CVCD`
}

function FormatSwapExpect(amount) {
    const value = Number(amount)
    if (!Number.isFinite(value) || value <= 0) return '0'
    return (Math.round((value + Number.EPSILON) * 100) / 100).toLocaleString()
}

function FormatRemainDays(time) {
    const value = Number(time)
    if (!Number.isFinite(value) || value <= 0) return 0
    return Math.ceil(value / 1000 / 60 / 60 / 24)
}

function ClaimCVCButton({disabled}) {
    const button = useClaimCvcdSwapAll()
    button.disabled = disabled
    return <Button {...button} />
}

function ClaimUSDTButton({disabled}) {
    const button = useReleaseCvcdSwapUSDTAll()
    button.disabled = disabled
    return <Button {...button} />
}

function LockedCVCOrdersDialog({orders}) {
    const {t} = useTranslation()

    return (
        <Card>
            <TextM block>{t('Locked')} CVC {t('Orders')}</TextM>
            <WhiteSpace />
            <Hr />
            <LoadingBlock loading={false}>
                {
                    orders.map(v => (
                        <div key={v.id}>
                            <WhiteSpace />
                            <TextS block color='2'>{t('Order')} #{v.id + 1}</TextS>
                            <FlexBLock>
                                <TextS color='2'>{t('Locked')} <TextS>{EtherToInt(v.cvcAmount)}</TextS> CVC</TextS>
                                <TextS color='2'>{t('Remain')} <TextS>{FormatRemainDays(v.unlockRemainTime)}</TextS> {t('Days')}</TextS>
                            </FlexBLock>
                            <WhiteSpace />
                            <Hr />
                        </div>
                    ))
                }
            </LoadingBlock>
        </Card>
    )
}

function UnlockCVC({swapData}) {
    const {t} = useTranslation()
    const [open, setOpen] = useState(false)
    const lockedOrders = swapData.orders.filter(v => !v.claimed && !v.claimable)
    const claimDisabled = (swapData.totalClaimableCVC * 1) <= 0

    return (
        <>
            <WhiteSpace />
            <FlexBLock>
                <div>
                    <TextM block>{t('Unlock')} CVC</TextM>
                    <TextLinear style={{fontSize: '24px'}} block>{EtherToInt(swapData.totalClaimableCVC)}</TextLinear> <TextM color='2'> / CVC</TextM>
                    <TextS onClick={() => setOpen(true)} color='2' block>
                        {t('Locked')} CVC <TextS>{EtherToInt(swapData.totalLockedCVC)}</TextS>
                    </TextS>
                </div>
                <ClaimCVCButton disabled={claimDisabled} />
            </FlexBLock>
            <Dialog value={open} onChange={setOpen}>
                <LockedCVCOrdersDialog orders={lockedOrders} />
            </Dialog>
        </>
    )
}

function StakeOrders({swapData}) {
    const {t} = useTranslation()
    const orders = swapData.usdtReleaseOrders || []
    const claimDisabled = (swapData.totalClaimableUSDT * 1) <= 0
    return (
        <Card>
            <FlexBLock>
                <div>
                    <TextM block>{t('Claimable')} USDT</TextM>
                    <TextLinear style={{fontSize: '24px'}} block>{EtherToInt(swapData.totalClaimableUSDT)}</TextLinear> <TextM color='2'> / USDT</TextM>
                </div>
                <ClaimUSDTButton disabled={claimDisabled} />
            </FlexBLock>
            <WhiteSpace />
            <Hr />
            <WhiteSpace />
            <TextM block>{t('My USDT Release Orders')}</TextM>
            <WhiteSpace />
            <Hr />
            <LoadingBlock loading={false}>
                {
                    orders.map(v => (
                        <div key={v.id}>
                            <WhiteSpace />
                            <TextS block color='2'>{t('Order')} #{v.id + 1}</TextS>
                            <TextM block color='2'> <TextM>{EtherToInt(v.claimableUSDT)}</TextM> USDT</TextM>
                            <FlexBLock>
                                <TextS  color='2'>{t('Total')} <TextS> {EtherToInt(v.usdtAmount)}</TextS> USDT </TextS>
                                <TextS  color='2'>{t('Released')} <TextS>{EtherToInt(v.releasedUSDT)}</TextS> USDT</TextS>
                            </FlexBLock>
                            <FlexBLock>
                                <TextS block color='2'>{t('Start')} <TextS>{v.startDate}</TextS></TextS>
                                <TextS block color='2'>{t('Remain')} <TextS>{FormatRemainDays(v.unlockRemainTime)}</TextS> {t('Days')}</TextS>
                            </FlexBLock>
                            <WhiteSpace />
                            <Hr />
                        </div>
                    ))
                }
            </LoadingBlock>
        </Card>
    )
}

function CvcStake({swapData}) {
    const {t} = useTranslation()
    const {balances} = useBalance()
    const {
        button,
        amountInput
    } = useStakeCvcForCvcdSwap()
    const stakeAmount = amountInput.value
    const stakeReward = StakeReward(stakeAmount, swapData)
    const amount = Number(stakeAmount)
    button.disabled = stakeAmount === '' || !Number.isFinite(amount) || amount <= 0 || amount > (balances.CVC * 1)
    const maxStake = () => {
        amountInput.onChange(balances.CVC || 0)
    }

    return (
        <>
            <Card type='j'>
                <FlexBLock>
                    <div>
                        <TextM block>CVC {t('Stake')}</TextM>
                        <TextS color='2'>{t('Stake CVC for')} {STAKE_WEEKS} {t('weeks')}</TextS>
                    </div>
                    <NodeType i='2'>{StakeRewardLabel(swapData)}</NodeType>
                </FlexBLock>
                <WhiteSpace />
                <FlexBLock>
                    <TextS>{t('Balance')} <TextLinear>{EtherToInt(balances.CVC)}</TextLinear> CVC</TextS>
                    <TextS color='2'>{t('Quota')} 1:1</TextS>
                </FlexBLock>
                <Input
                    after={<Button size='small' type='d' onClick={maxStake}>{t('Max')}</Button>}
                    input={amountInput}
                />
                <WhiteSpace />

                <TextS block color='2'>{t('Expect')} <TextS>{EtherToInt(stakeReward)}</TextS> CVCD</TextS>
                <TextS color='2'>{t('Unlock Cycle')} <TextS>{STAKE_WEEKS} </TextS> {t('Weeks')}</TextS>
                <UnlockCVC swapData={swapData} />
                <WhiteSpace />
                <Button type='b' style={{width: '100%'}} {...button} />
            </Card>
            <WhiteSpace />
            <StakeOrders swapData={swapData} />
        </>
    )
}

function LegacySwap() {
    const {t} = useTranslation()
    const {balances} = useBalance()
    const swapData = useCvcdSwapData()
    const {
        button,
        amountInput
    } = useSwap()
    const amount = Number(amountInput.value)
    const swapQuota = swapData.exchangeQuota || 0

    console.log(
        "swapData.feeDenominator", swapData.feeDenominator
    )
    console.log(
        "swapData.feeRate", swapData.feeRate
    )

    const feeRate = swapData.feeDenominator > 0 ? swapData.feeRate / swapData.feeDenominator : 0
    const expectAmount = amount > 0 ? amount * Math.max(0, 1 - feeRate) : 0
    const disable = amountInput.value === '' ||
        !Number.isFinite(amount) ||
        amount <= 0 ||
        amount > (balances.CVCD * 1) ||
        amount > (swapQuota * 1)
    button.disabled = disable
    const max = () => {
        amountInput.onChange(Math.min(balances.CVCD * 1, swapQuota * 1))
    }

    return (
        <Container>
            <TextMax><IconImg style={{width: '26px', height: 'auto', verticalAlign: 'inherit'}} src='./swaptitle.png'/> {t('Swap CVCD V2')}</TextMax>
            <WhiteSpace />
            <Card type='j'>
                <TextM>{t('Swap CVCD')}</TextM>
                <WhiteSpace />
                <TextS>{t('Balance')} <TextLinear linear='2'>{EtherToInt(balances.CVCD)}</TextLinear> CVCD</TextS>
                <Input
                    after={<Button size='small' type='d' onClick={max}>{t('Max')}</Button>}
                    input={amountInput}
                />
                <WhiteSpace />
                <TextS block color='2'>{t('Swap Quota')} <TextS>{EtherToInt(swapQuota)} </TextS> USDT</TextS>
                <TextS color='2'>{t('Expect')} <TextS>{FormatSwapExpect(expectAmount)}</TextS> USDT</TextS>
                <WhiteSpace />
                <Button type='b' style={{width: '100%'}} {...button} />
            </Card>
            <WhiteSpace />
            <CvcStake swapData={swapData} />
        </Container>
        
    )
}

export default function Swap() {
    return CVCD_EXIT_ENABLED && manifest.features?.cvcdExit?.enabled ? <CvcdExit /> : <>
        <Container><TextS block><ExitPendingNotice /></TextS><WhiteSpace /></Container>
        <LegacySwap />
    </>
}
function ExitPendingNotice() {
    const { t } = useTranslation()
    return t('Early unlock is not yet enabled for this deployment.')
}

const COLOR = [
    "rgb(171 255 0)",
    "rgb(255 199 0)",
    "rgb(255 241 0)",
    "rgb(255 0 161)",
    "rgb(0 242 255)",
]
function NodeType({children, i = 0}) {
    return <NodeBlock i={i}>{children}</NodeBlock>
}

const NodeBlock = styled('span')`
    background-color: ${p => COLOR[p.i] || COLOR[0]};
    color: #000;
    font-size: 10px;
    padding: 2px 4px;
    border-radius: 4px;
    margin-left: 4px;
    box-shadow: 0px 0px 6px #fdffb791;
`
